<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Casos activos con informe de liquidación</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Casos activos con informe de liquidación</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
          <div slot="footer">
                <div class="form-actions">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="descargarExcel"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                    </el-row>                
                </div>
            </div>
        </b-card>
      
      </b-col>
    </b-row>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInformes from "@/components/services/apiInformes";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";

import XLSX from "xlsx";

export default {
  name: "TareasActividades",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      nombreexcel: "CasosActivosConInformeDeLiquidación",
      //titlesDinamic: [],
      titles: [
        {
          prop: "Ejecutivo",
          label: "Ejecutivo",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "Siniestro",
          label: "Siniestro",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Asegurado",
          label: "Asegurado",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Beneficiario",
          label: "Beneficiario",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Deudor",
          label: "Deudor",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "RUT Deudor",
          label: "RUT Deudor",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "Monto Impago Inicial MonPol",
          label: "Impago Inicial MonPol",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Monto Impago",
          label: "Monto Impago",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Coaseguro",
          label: "Coaseguro",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Parte Cubierta",
          label: "Parte Cubierta",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Moneda Pol",
          label: "Moneda Pol",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "Provisión Benef. MonPol",
          label: "Provisión Benef. MonPol",
          align: "right",
          minwidth:'200'
        },
        {
          prop: "Fecha Aviso",
          label: "Fecha Aviso",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "Fecha Asig. Liquidador",
          label: "Fecha Asig. Liquidador",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Fecha Est. Config",
          label: "Fecha Est. Config",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Fecha Recepción Informe",
          label: "Fecha Recepción Informe",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Fecha Excepción",
          label: "Fecha Excepción",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Instancia que autorizó",
          label: "Instancia que autorizó",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "N° de acta",
          label: "N° de acta",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "% Monto Impago Excepcionado",
          label: "% Monto Impago Excepcionado",
          align: "right",
          minwidth:'250'
        },
        {
          prop: "Moneda Monto Excepcionado",
          label: "Moneda",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "Monto Excepcionado",
          label: "Monto",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Observaciones",
          label: "Observaciones",
          align: "left",
          minwidth:'300'
        }
      ],
      filters: [
        {
          prop: ["Ejecutivo",
                "Siniestro",
                "Asegurado",
                "Beneficiario",
                "Deudor",
                "RUT Deudor",
                "Monto Impago Inicial MonPol",
                "Monto Impago",
                "Coaseguro",
                "Parte Cubierta",
                "Moneda Pol",
                "Provisión Benef. MonPol",
                "Fecha Aviso",
                "Fecha Asig. Liquidador", 
                "Fecha Est. Config",
                "Fecha Recepción Informe", 
                "Fecha Excepción",
                "Instancia que autorizó",
                "N° de acta",
                "% Monto Impago Excepcionado",
                "Moneda Monto Excepcionado",
                "Monto Excepcionado",
                "Observaciones"
                 ],
          value: ""
        }
      ],

      mostrarFechas: true,
      datosFormulario: {},
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400
      },
    };
  },
  components:{
    Datepicker,
  },
  methods: {
    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];

      return apiInformes
        .pre_insercion_siniactconinf(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();

      return apiInformes
        .recuperar_siniactconinf(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then(response => {
          this.data  = response.data.res1;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          if (this.data != null){
            this.exportar = true;
            /*
            for(var i = 0; i < response.data.res1.length; i++){
                this.data[i]["Correlativo"] = (i + 1);
            }*/
          } else {
            this.exportar = false;
          }

        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if ((column.property == "Fecha Aviso" || 
           column.property == "Fecha Asig. Liquidador" ||
           column.property == "Fecha Est. Config" ||
           column.property == "Fecha Recepción Informe" ||
           column.property == "Fecha Excepción"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      }
      else if ((column.property == "Provisión Benef. MonPol" ||
                column.property == "% Monto Impago Excepcionado" ||
                column.property == "Monto Excepcionado" ||
                column.property == "Coaseguro" ||
                column.property == "Parte Cubierta"
              ) && row[column.property]){
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      }
      else if ((column.property == "Monto Impago Inicial MonPol" ||
                column.property == "Monto Impago"
               ) && row[column.property]){
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format();
        }
      }
      else {
        return row[column.property];
      }
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Casos activos con informe de liquidación</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan=6 class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Caso</td>\n";
        cuerpo += "<td colspan=2 class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Montos</td>\n";
        cuerpo += "<td colspan=2 class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Cobertura</td>\n";
        cuerpo += "<td colspan=2 class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Provisión</td>\n";
        cuerpo += "<td colspan=5 class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Fechas</td>\n";
        cuerpo += "<td colspan=6 class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Excepción</td>\n";
        //cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >ALGUN TEXTO </td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i].label+"</td>\n";
        }
      cuerpo += "</tr>\n";


      //Data bloque 1
      for (var key in this.data) {
          
          
          if(this.data[key]["Ejecutivo"] == undefined){
              this.data[key]["Ejecutivo"] = "";
          }
          if(this.data[key]["Siniestro"] == undefined){
              this.data[key]["Siniestro"] = "";
          }
          if(this.data[key]["Asegurado"] == undefined){
              this.data[key]["Asegurado"] = "";
          }
          if(this.data[key]["Beneficiario"] == undefined){
              this.data[key]["Beneficiario"] = "";
          }
          if(this.data[key]["Deudor"] == undefined){
              this.data[key]["Deudor"] = "";
          }
          if(this.data[key]["RUT Deudor"] == undefined){
              this.data[key]["RUT Deudor"] = "";
          }
          if(this.data[key]["Monto Impago Inicial MonPol"] == undefined){
              this.data[key]["Monto Impago Inicial MonPol"] = "";
          }
          if(this.data[key]["Monto Impago"] == undefined){
              this.data[key]["Monto Impago"] = "";
          }
          if(this.data[key]["Coaseguro"] == undefined){
              this.data[key]["Coaseguro"] = "";
          }
          if(this.data[key]["Parte Cubierta"] == undefined){
              this.data[key]["Parte Cubierta"] = "";
          }
          if(this.data[key]["Moneda Pol"] == undefined){
              this.data[key]["Moneda Pol"] = "";
          }
          if(this.data[key]["Provisión Benef. MonPol"] == undefined){
              this.data[key]["Provisión Benef. MonPol"] = "";
          }
          if(this.data[key]["Fecha Aviso"] == undefined){
              this.data[key]["Fecha Aviso"] = "";
          }
          if(this.data[key]["Fecha Asig. Liquidador"] == undefined){
              this.data[key]["Fecha Asig. Liquidador"] = "";
          }
          if(this.data[key]["Fecha Est. Config"] == undefined){
              this.data[key]["Fecha Est. Config"] = "";
          }
          if(this.data[key]["Fecha Recepción Informe"] == undefined){
              this.data[key]["Fecha Recepción Informe"] = "";
          }
          if(this.data[key]["Fecha Excepción"] == undefined){
              this.data[key]["Fecha Excepción"] = "";
          }
          if(this.data[key]["Instancia que autorizó"] == undefined){
              this.data[key]["Instancia que autorizó"] = "";
          }
          if(this.data[key]["N° de acta"] == undefined){
              this.data[key]["N° de acta"] = "";
          }
          if(this.data[key]["% Monto Impago Excepcionado"] == undefined){
              this.data[key]["% Monto Impago Excepcionado"] = "";
          }
          if(this.data[key]["Moneda Monto Excepcionado"] == undefined){
              this.data[key]["Moneda Monto Excepcionado"] = "";
          }
          if(this.data[key]["Monto Excepcionado"] == undefined){
              this.data[key]["Monto Excepcionado"] = "";
          }
          if(this.data[key]["Observaciones"] == undefined){
              this.data[key]["Observaciones"] = "";
          }
          

          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Ejecutivo"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Siniestro"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Asegurado"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Beneficiario"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Deudor"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["RUT Deudor"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Monto Impago Inicial MonPol"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Monto Impago"]).format('0,0')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Coaseguro"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Parte Cubierta"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Moneda Pol"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Provisión Benef. MonPol"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Aviso"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Asig. Liquidador"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Est. Config"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Recepción Informe"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["Fecha Excepción"])+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Instancia que autorizó"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["N° de acta"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["% Monto Impago Excepcionado"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Moneda Monto Excepcionado"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Monto Excepcionado"]).format('0,0.00')+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Observaciones"]+"</td>\n";

          cuerpo += "</tr>\n";
      }



      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
